import styled, { css } from 'styled-components';
import { FormGroup } from '@oneaudi/unified-web-components';
import { SYS_COLOR_FOREGROUND_NEUTRAL_400_LIGHT, SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_3_XL, SYS_FONT_SIZES_RELATIVE_100, SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT, } from '@oneaudi/unified-web-common';
export const FormWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_100};
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0px;
  }
`;
export const RadioWrapperToOverwriteLegacyCSS = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 20px;
`;
export const FormElementWrapper = styled.div `
  margin-block-end: ${SYS_SPACE_FIXED_300};
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: center;
`;
export const ReadOnlyFormElementWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ReadOnlyGroup = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_350};
  margin-left: ${SYS_SPACE_FIXED_300};
  margin-right: ${SYS_SPACE_FIXED_300};
  margin-top: ${SYS_SPACE_FIXED_350};
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  flex-direction: column;
`;
export const RateWrapper = styled.div `
  display: flex;
  input {
    font-size: x-large;
    font-weight: bold;
    padding: 0px;
  }
  div #Rate__hint-message {
    flex-direction: row-reverse;
    margin: 0px;
  }
`;
export const WebCalcErrWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const WebCalcErrContainer = styled.div `
  display: flex;
  flex-direction: row;
  margin: 0px ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_300};
  color: ${SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK};

  p {
    color: ${SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK};
    margin: 0px;
  }
  .web-calc-error-headline {
    color: var(--Global-Color-Typography-Headline-Default, #333);
  }
`;
export const FormColumnWrapper = styled.div `
  flex: 1;
  margin-bottom: ${SYS_SPACE_FIXED_300};
`;
export const ReadOnlyColumn = styled.div `
  flex: 1;
  background-color: #fff;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
  margin-bottom: ${SYS_SPACE_FIXED_300};
  height: 100%;
  width: 100%;
`;
export const ProductWrapper = styled.div `
  display: block;
  flex-wrap: wrap;
`;
export const popupContentStyles = css `
  width: 600px;
  max-width: none;
`;
export const HeadingWrapper = styled.div `
  h2 {
    hyphens: auto;
    word-break: break-word;
  }
`;
export const RadioWrapper = styled(FormGroup) `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;

  > legend {
    font-size: ${SYS_FONT_SIZES_RELATIVE_100};
    font-weight: 700;
    margin: 0 0 ${SYS_SPACE_FIXED_300} 0;
    color: ${SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT};
  }
  > legend + div {
    flex-direction: row;
  }
`;
export const InputWrapper = styled.div `
  width: 90%;
`;
export const CTAWrapper = styled.div `
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_100};
  align-self: stretch;
`;
export const WrapperToOverwriteLegacyCSS = styled.div `
  > .downPayment > div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;

    > div:first-child {
      display: flex;
      flex-grow: 1;
    }
    > div:last-child {
      text-align: start;
      padding-left: 0px;
      padding-right: 0px;
      min-width: 15px;
    }
  }
  input {
    @media screen and (max-width: 479px) {
      height: auto !important;
    }
  }
`;
export const ReadonlyInputWrapper = styled.div `
  width: 100%;
  span {
    hyphens: auto;
    word-break: break-word;
  }
  input {
    display: none;
  }
  .read-only-value {
    color: ${({ IsLoading }) => (IsLoading ? SYS_COLOR_FOREGROUND_NEUTRAL_400_LIGHT : undefined)};
  }
`;
export const InfoIcontainer = styled.div `
  display: block;
  width: 16px;
  align-self: center;
  margin-left: ${SYS_SPACE_FIXED_100};

  div {
    margin: 0px;
  }
`;
export const FlexWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: flex;
    align-items: center;

    button {
      margin-bottom: 10px;
    }
  }
`;
export const RateFlexWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  margin-block-end: 0px;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};

  span {
    display: flex;
    align-items: center;

    button {
      margin-bottom: 10px;
    }
  }
`;
export const ReadOnlyValue = styled.div `
  p {
    word-break: keep-all;
    white-space: nowrap;
  }
`;
export const BreakdownValueWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  padding-left: 10px;

  p {
    line-height: inherit !important;
  }
`;
export const FinanceModalWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_RELATIVE_2_XL};
  margin-bottom: ${SYS_SPACE_RELATIVE_3_XL};
`;
